/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, { student_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`student/${student_id}/schedules?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { student_id, schedule_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `student/${student_id}/schedule/${schedule_id}?${new URLSearchParams(
            query
          )}`
        )
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getListDemo({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`student-schedules/list-demo?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST_DEMO", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setPerPageDemo({ commit }, data) {
    commit("SET_PER_PAGE_DEMO", data);
  },

  setCurrentPageDemo({ commit }, data) {
    commit("SET_CURRENT_PAGE_DEMO", data);
  },
  getEnrollmentCoursesClass({ commit }, { student_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`student/${student_id}/classes?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_CLASSES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEnrollmentCourses({ commit }, { student_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`student/${student_id}/courses?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_COURSES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
